"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const complex_data_1 = require("complex-data");
class ComplexSelect extends complex_data_1.SelectList {
    constructor(initOption) {
        super(initOption);
        this.status = 'un';
        this.enable = initOption.enable;
        this.getData = initOption.getData;
    }
    getList(option) {
        if (this.enable && !option) {
            option = {
                filter: 'enable'
            };
        }
        return super.getList(option);
    }
    $loadData(force) {
        if (force || this.status !== 'ed') {
            return new Promise((resolve, reject) => {
                this.status = 'ing';
                this.getData().then((res) => {
                    this.status = 'ed';
                    this.setList(res.list);
                    resolve(res);
                }).catch(err => {
                    this.status = 'un';
                    reject(err);
                });
            });
        }
        else {
            return Promise.resolve({ status: 'success' });
        }
    }
}
exports.default = ComplexSelect;
